export default {
    LightPrimary1: "#FAFAFA",
    LightPrimary2: "#E3E3E3",
    DarkPrimary1: "#1B3C59",
    DarkPrimary2: "#456173",
    SecondaryColor1: "#295BA7",
    SecondaryColor2: "#93DEFF",
    AccentColor: "#EA1010",
};
